module.exports = __webpack_public_path__ + "assets/ce8b8dd2ac8df8cb2ab6834777af3c8a.png";